<template>
    <b-container id="home">
        <b-row>
            <b-form-group   id="categoryInputGroup"
                            horizontal
                            :label-cols="6"
                            label="Kategorien:"            
                            label-for="categoryInput">
                <b-form-select id="categoryInput"
                               v-model="filterCategoryID"
                               :options="categories"
                               >
                </b-form-select>
            </b-form-group> 
        </b-row>
        <b-row>
            <b-table hover :items="filteredPictures" :fields="fields">
                <template slot="url" slot-scope="data">
                    <b-img-lazy :src="data.value"  fluid alt="Responsive image" ></b-img-lazy>
                </template>
                <template slot="front_page" slot-scope="data">
                    <div v-if="data.value === 'front-page'"class="btn btn-outline-success "> Ja </div>
                </template>

                <template slot="active" slot-scope="data">
                    <div v-if="data.value === 'f'"class="btn btn-outline-secondary "> Nein </div>
                    <div v-else="data.value === 'f'"class="btn btn-outline-success "> Ja </div>
                </template>
                <template slot="update", slot-scope="data">
                    <b-link :to="{ name: 'UpdatePicturePage', params: { uuid: data.item.uuid }}" class="btn btn-primary">X</b-link>
                </template>
                <template slot="delete", slot-scope="data">
                    <button @click="deletePicture(data.item.uuid)" class="btn btn-danger">X</button>
                </template>
            </b-table>

        </b-row>
    </b-container>
</template>

<script>
import { Auth, Hub } from 'aws-amplify';
import AmplifyStore from '../store/store';
import {HTTP} from './http-common';

export default {

    name: 'Home',
    data () {
        return {
            filterCategoryID: 'Alle',
            fields: [
                {
                    key: 'url',
                    label: 'Bild'
                },
                {
                    key: 'category_name',
                    label: 'Kategorie',
                    sortable: true
                }, 
                {
                    key: 'title',
                    label: 'Titel'
                },           
                {
                    key: 'front_page',
                    label: 'Startseite?',
                    sortable: true
                },           
                {
                    key: 'active', label: 'Aktiv?', sortable: true
                },           
                'update',
                'delete'
            ],
            pictures: [],
            categories: []
        }
    },
    computed: {
        filteredPictures() {
            let pictures = this.pictures
            if(this.filterCategoryID !== 'Alle') {
                pictures = pictures.filter( p => p.category_name.includes(this.filterCategoryID));
            }
            return pictures
        },
    },
    methods: {
        allPictures(){
            HTTP.get(`pictures`, {headers: {Authorization: `Bearer ${AmplifyStore.state.user.signInUserSession.idToken.jwtToken}`}}
            ).then(response => {
                this.pictures = response.data;
                
            }).catch(e => {
                console.log(e)
            })
        },
        deletePicture(uuid) {
            var r = confirm("Bild wirklich löschen?");
            if (r == true) {
                HTTP.delete(
                    `picture/${uuid}`, 
                    {headers: {Authorization: `Bearer ${AmplifyStore.state.user.signInUserSession.idToken.jwtToken}`}})
                    .then(response => {
                        this.allPictures();
                        console.log('successfull delete')
                    });
            }
        },
        getCategories() {
            HTTP.get(`categories`)
            .then(response =>{
                    this.categories = response.data;
                    var i;
                    for (i = 0; i < this.categories.length; i++){
                        this.categories[i].value = this.categories[i].name;
                        this.categories[i].text = this.categories[i].name;
                    }
                    this.categories.push({value: 'Alle', text: 'Alle'})
                });
        },

    },
    created: function(){
        this.getCategories();
        this.allPictures();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
    max-height: 120px;
}
#index-page {
    margin-top: 1em;
}

.btn-outline-success:hover {
    background: none;
    color: #28a745;
}
.btn-outline-danger:hover {
    background: none;
    color: #dc3545;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue